module.exports = __webpack_public_path__ + "img/nodata.113722d9.png";